export class Ninja {
    age: number | null = null;
    gender: string | null = null;
    height: number | null = null;
    name: string | null = null;
    weight: number | null = null;

    id() {
        if(this.name){
            return this.name.toLowerCase().replace(/ /g, "_");
        }
        return null;
    }

    tostring() {
        return this.name;
    }
}


